import * as React from "react";

import { cn } from "@/shared/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // 配色走皮肤 token(border-input/bg-background/text-foreground),3 套皮肤都可读。
          // 此前硬编码 cyber 深底 + 等宽霓虹边 → standard/comic(浅色)下深底白字看不清。
          // cyber 的等宽 + 霓虹边/聚焦光改由 skin-cyber.css `.cyber-input` 覆写。
          "cyber-input flex h-10 w-full rounded-md px-3 py-2 text-base md:text-sm",
          "border border-input bg-background text-foreground",
          "transition-all duration-200",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-muted-foreground",
          "hover:border-ring/60",
          "focus-visible:outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/40",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
